'use strict';

module.exports = function ($stateProvider) {

    $stateProvider
        .state('dashboard.statistics', {
            url: '/statistics',
            templateUrl: 'dashboard-statistics/dashboard-statistics.html',
            controller: 'dashboardStatisticsCtrl as ctrl',
            resolve: {},
            data: {
                authorizedRoles: ['admin','owner']
            }
        });
};
